import { routes } from '../../../../shared/routes'

export const getPromoTabLink = (tabValue: string) => routes.ROUTES_PROMO.promoTab.replace(':tabValue', tabValue)
export const getPromoByIdLink = (id: string, tabValue: string) => routes.ROUTES_PROMO.promoTabById.replace(':id', id).replace(':tabValue', tabValue)
